/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BackButton } from '../components/BackButton';
import ContactCard from '../components/ContactCard';
import { PageContainer } from '../components/layout/PageContainer';
import YesNoAction from '../components/YesNoAction';
import { selectContactInfo, selectUserContactDetails } from '../features/azure-b2c/storage';
import { TestIds } from '../testIds';
import { PRODUCTS_ROUTE } from '../features/products/products.routes';

export const EnquiryRequestSent = () => {
  const userDetails = useSelector(selectUserContactDetails);
  const navigate = useNavigate();

  const relationshipOwner = useSelector(selectContactInfo);

  return (
    <PageContainer data-testid={TestIds.pages.cart}>
      <BackButton text='Products' onClick={() => navigate(PRODUCTS_ROUTE)} />
      <>
        <YesNoAction
          display='Enquiry Request Sent'
          subheading={
            <Typography variant='h4' sx={{ mt: 4, mb: 2 }}>
              Thanks {userDetails?.firstName}!
            </Typography>
          }
          body={
            <Typography variant='body2'>
              Your request has been sent to your Farmlands representative&nbsp;
              {relationshipOwner?.fullName} to review. They will contact you directly to inform you
              when this item will be back in stock.
            </Typography>
          }
        />
        <Box mt={4} />
        <ContactCard
          sx={{ mt: 4 }}
          title='If you have any questions please contact your Farmlands representative.'
          data-testid={TestIds.components.contactCard.card}
          {...relationshipOwner}
        />
      </>
    </PageContainer>
  );
};
